jQuery(document).ready(function($) {

	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
            jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
            jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

    function tense_sticky_nav() {
        var footer_height = 120;
        var nav_height = $('#casestudy-nav > .menu').innerHeight();
        var bottom_anchor = $('.casestudy-single').offset().top + $('.casestudy-single').innerHeight() - footer_height - nav_height;

        var $el = $('#casestudy-nav');

        if (window.scrollY < footer_height + 15) {
            $el.removeClass('is-stuck is-stuck-bottom');
        } else if (window.scrollY >= bottom_anchor) {
            $el.removeClass('is-stuck is-stuck-bottom');
            $el.addClass('is-stuck-bottom');
        } else if (window.scrollY >= footer_height + 15) {
            $el.removeClass('is-stuck is-stuck-bottom');
            $el.addClass('is-stuck');
        }
    }

    $('.casestudy-archive__cats select').change(function() {
        $(this).closest('form').submit();
    });

    // tense_sticky_nav();

    // $(window).on('scroll resize', Foundation.util.throttle(tense_sticky_nav, 200));

});
